export const licenseKey='ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImI2NDAxNjRlLTUxNDgtNDNlNy1iMjExLWQ2MjRmYzExMjcyNSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.rm2e/YWuTMcCOJ9Ix8PeUjUci4uZVTYU/7nYSCbIHF1xwMQzLx/LsnLBLUe58LNBWiPydJdU1DWM74bLaN7JEHKFEgs7r+Q3rE2nOD83Va+LKExn0n/cvSmGxpc8tagMh3ZlYQ=='

